module.exports = __webpack_public_path__ + "img/conference12.f3ac82bb.jpg";